import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class NotEqualToValidationRule extends ValidationRule {
  private forbiddenValue: any;

  constructor(forbiddenValue: any, key: string) {
    if (!key) {
      key = ValidationTypes.notEqualTo;
    }

    super(key);

    this.forbiddenValue = forbiddenValue;
  }

  isValid(value: any): boolean {
    return value != this.forbiddenValue;
  }
}
